module.exports = __webpack_public_path__ + "img/retail04.852dc039.png";